import React from 'react';
import { useReveal } from '../lib/useReveal';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/cqyU2WmkZYHP8KwBViHHvF/ChatGPT_Image_22_jun_2026,_21_32_29.png';
export function HeroSection() {
  const [ref1, vis1] = useReveal();
  return <section className="pt-5 pb-6 md:pt-8 md:pb-10 px-5 sm:px-6 overflow-hidden relative bg-[#faf5fc]" data-id="element-211">
      <div ref={ref1} className={`reveal container mx-auto max-w-3xl text-center relative z-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-212">
        {/* Eyebrow */}
        <p className="text-[#c9a14d] text-[10px] sm:text-xs font-bold tracking-[0.18em] uppercase mb-3 leading-relaxed max-w-xl mx-auto" style={{
        fontFamily: "'Inter', sans-serif"
      }} data-id="element-213">
          ✨Aprende Reiki desde cero hasta la Maestría
        </p>

        {/* Tagline */}
        <p className="text-[#3d2a5f] font-bold md:text-lg mb-2 text-[24px]" data-id="element-214">
          Empieza tu camino en Reiki.
        </p>

        {/* Description */}
        <p className="text-[#6b5a85] text-sm md:text-base max-w-xl mx-auto mb-5" data-id="element-215">
          El sistema completo para aprender con tomos profesionales, bonos
          exclusivos y certificado incluido. Sin clases presenciales, sin
          horarios. A tu ritmo y con acceso inmediato.
        </p>

        {/* Compact Hero Image */}
        <div className="block mx-auto w-full max-w-md sm:max-w-xl mb-4 relative" data-id="element-216">
          <img src={HERO_IMG} alt="MegaPack Maestría Reiki" className="w-full object-contain block drop-shadow-[0_15px_30px_rgba(61,42,95,0.15)]" data-id="element-217" />
        </div>

        {/* Social proof */}
        <div className="flex flex-col items-center gap-1.5 mb-4" data-id="element-218">
          <p className="text-[#3d2a5f] text-sm font-bold flex items-center gap-2" data-id="element-219">
            <span className="text-[#c9a14d]" data-id="element-220">⭐⭐⭐⭐⭐</span>
            <span data-id="element-221">4.9/5 · +800 alumnos satisfechos</span>
          </p>
          <p className="text-[#6b5a85] text-xs font-semibold flex items-center gap-1.5" data-id="element-222">
            🔥 Más de 60 estudiantes accedieron esta semana
          </p>
        </div>

        {/* CTA */}
        <div className="flex flex-col items-center gap-2 w-full max-w-md mx-auto" data-id="element-223">
          <a href="#pricing-offer" className="w-full block px-4 py-4 rounded-xl text-white font-bold text-sm sm:text-base tracking-wider uppercase transition-all shadow-[0_10px_30px_rgba(201,161,77,0.4)] hover:shadow-[0_15px_40px_rgba(201,161,77,0.5)] hover:-translate-y-1 bg-gradient-to-r from-[#c9a14d] to-[#b8945a] border border-[#c9a14d] text-center" style={{
          fontFamily: "'Inter', sans-serif"
        }} data-id="element-224">
            ✨ SÍ, QUIERO APRENDER REIKI
          </a>
          <p className="text-[#6b5a85] text-xs font-medium" data-id="element-225">
            Acceso inmediato luego de la compra.
          </p>
        </div>
      </div>
    </section>;
}